// TeacherDashboard.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ChatWithSessions from './Chat/ChatWithSessions';
import ImageGenerator from './ImageGenerator';
import TeacherManagementDashboard from './Teacher/TeacherManagementDashboard';

const TeacherDashboard = () => {
  const { user } = useAuth();
  const [activeMode, setActiveMode] = useState('chat'); // 'chat', 'image', 'management'

  // 탭 전환 시 모드만 변경 (스크롤 위치 유지)
  const handleModeChange = (mode) => {
    setActiveMode(mode);
  };

  // 컴포넌트 마운트 시 스크롤 상단으로 이동
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-7xl mx-auto p-6">
        {/* 헤더 */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                👨‍🏫 교사 대시보드
              </h1>
              <p className="text-gray-600 mt-2">
                안녕하세요, {user.username} 선생님! 청해 AI와 함께 안전한 교육을 시작해보세요.
              </p>
            </div>
            <div className="flex items-center justify-center h-16 w-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl shadow-lg">
              <span className="text-white text-sm font-bold">SafeAI</span>
            </div>
          </div>

          {/* 모드 선택 탭 */}
          <div className="flex flex-wrap space-x-2 sm:space-x-4 border-b border-gray-200">
            <button
              onClick={() => handleModeChange('chat')}
              className={`py-3 px-4 sm:px-6 font-medium border-b-2 transition-colors text-sm sm:text-base ${
                activeMode === 'chat'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              💬 AI 채팅
            </button>
            <button
              onClick={() => handleModeChange('image')}
              className={`py-3 px-4 sm:px-6 font-medium border-b-2 transition-colors text-sm sm:text-base ${
                activeMode === 'image'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              🎨 이미지 생성
            </button>
            <button
              onClick={() => handleModeChange('management')}
              className={`py-3 px-4 sm:px-6 font-medium border-b-2 transition-colors text-sm sm:text-base ${
                activeMode === 'management'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              🏫 학생 활동 관리
            </button>
          </div>
        </div>

        {/* 콘텐츠 영역 */}
        {activeMode === 'chat' ? (
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-4 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">💬 AI 채팅</h2>
              <p className="text-gray-600 text-sm">교육 관련 질문이나 수업 아이디어를 얻어보세요</p>
            </div>
            <div className="h-[600px]">
              <ChatWithSessions />
            </div>
          </div>
        ) : activeMode === 'image' ? (
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-4 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">🎨 교육용 이미지 생성</h2>
              <p className="text-gray-600 text-sm">수업에 활용할 안전한 교육 이미지를 생성하세요</p>
            </div>
            <div className="h-[600px] overflow-y-auto">
              <ImageGenerator role={user.role} />
            </div>
          </div>
        ) : activeMode === 'management' ? (
          <TeacherManagementDashboard />
        ) : null}

        {/* 하단 링크 */}
        <div className="mt-8 bg-white rounded-lg shadow-lg p-6">
          <div className="border-t border-gray-200 pt-6">
            <div className="flex flex-wrap justify-center space-x-8 text-sm text-gray-600">
              <a 
                href="/privacy-policy" 
                className="hover:text-blue-600 transition-colors"
              >
                📋 초등학생 보호 정책
              </a>
              <a 
                href="/AI_학습_지원_서비스_이용_동의서.pdf" 
                download="AI_학습_지원_서비스_이용_동의서.pdf"
                className="hover:text-blue-600 transition-colors"
              >
                📄 학부모 동의서 다운로드
              </a>
              <a 
                href="mailto:purusil55@gmail.com" 
                className="hover:text-blue-600 transition-colors"
              >
                📧 Contact Us
              </a>
            </div>
            <div className="text-center mt-4 text-xs text-gray-500">
              <p>제작 지원: 완도SW센터</p>
              <p>앱 개발: 완도고등학교 국어교사 공지훈</p>
              <p>문의: purusil55@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherDashboard;
